// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.PageBaseWrapper_header-wrapper__y8lux {
  margin-top: 7.5rem;
}
@media (max-width: 1024px) {
  .PageBaseWrapper_header-wrapper__y8lux {
    margin-top: 5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/Page/PageBaseWrapper.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AC/BA;EACI,kBAAA;AAMJ;ADsDE;EC7DF;IAGQ,gBAAA;EAQN;AACF","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.header-wrapper {\n  margin-top: 7.5rem;\n}\n@media (max-width: 1024px) {\n  .header-wrapper {\n    margin-top: 5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-wrapper": `PageBaseWrapper_header-wrapper__y8lux`
};
export default ___CSS_LOADER_EXPORT___;
